/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Embed_Captions_Pricing_Processing_HelpInputs */



/**
* | output |
* | --- |
* | "Caption embedding and processing" |
*
* @param {Embed_Captions_Pricing_Processing_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const embed_captions_pricing_processing_help = /** @type {((inputs?: Embed_Captions_Pricing_Processing_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Embed_Captions_Pricing_Processing_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Incrustation et traitement des sous-titres")
	if (locale === "de") return /** @type {LocalizedString} */ ("Einbettung und Verarbeitung von Untertiteln")
	if (locale === "it") return /** @type {LocalizedString} */ ("Incorporamento ed elaborazione delle didascalie")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Встраивание и обработка субтитров")
	if (locale === "es") return /** @type {LocalizedString} */ ("Incorporación y procesamiento de subtítulos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("字幕嵌入和处理")
	if (locale === "ja") return /** @type {LocalizedString} */ ("キャプションの埋め込みと処理")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कैप्शन एम्बेडिंग और प्रोसेसिंग")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Incorporação e processamento de legendas")
	return /** @type {LocalizedString} */ ("Caption embedding and processing")
});